<template>
  <div></div>
</template>

<script>
export default {
  name: "TrackInfoComponent",
};
</script>
